module.exports = __webpack_public_path__ + "static/media/payments.f54d1a0a.svg";